import apiClient from '@/lib/axios';
import type {
  InsuranceCompanyDto,
  CreateInsuranceCompanyRequest,
  UpdateInsuranceCompanyRequest,
} from '../types/insurance';

interface ApiResult<T> {
  success: boolean;
  data: T;
  message?: string;
}

export const getInsuranceCompanies = async (
  isActive?: boolean
): Promise<InsuranceCompanyDto[]> => {
  const response = await apiClient.get<ApiResult<InsuranceCompanyDto[]>>('/insurance-companies', {
    params: isActive !== undefined ? { isActive } : undefined,
  });
  return response.data.data;
};

export const getInsuranceCompanyById = async (id: number): Promise<InsuranceCompanyDto> => {
  const response = await apiClient.get<ApiResult<InsuranceCompanyDto>>(
    `/insurance-companies/${id}`
  );
  return response.data.data;
};

export const createInsuranceCompany = async (
  data: CreateInsuranceCompanyRequest
): Promise<InsuranceCompanyDto> => {
  const response = await apiClient.post<ApiResult<InsuranceCompanyDto>>(
    '/insurance-companies',
    data
  );
  return response.data.data;
};

export const updateInsuranceCompany = async (
  id: number,
  data: UpdateInsuranceCompanyRequest
): Promise<InsuranceCompanyDto> => {
  const response = await apiClient.put<ApiResult<InsuranceCompanyDto>>(
    `/insurance-companies/${id}`,
    data
  );
  return response.data.data;
};

export const deleteInsuranceCompany = async (id: number): Promise<void> => {
  await apiClient.delete(`/insurance-companies/${id}`);
};
